export default __webpack_public_path__ + "static/backgroundPublisher-3513916ab260498db6ab60a8ae7bc294.jpg";